@if (items?.length > 0) {
    <mat-accordion
        displayMode="flat"
        [multi]="true"
        class="menu-accordion list"
        cdkDropList
        cdkDropListConnectedTo="entryList"
        (cdkDropListDropped)="drop($event)"
    >
        @for (page of items; track page; let i = $index) {
            <mat-expansion-panel
                cdkDrag
                [class.isleaf]="page.kind != 'directory'"
                [(expanded)]="page['expanded']"
                (click)="page.kind != 'directory' && pages.addTab(page, item)"
                (opened)="
                    page.kind == 'directory' &&
                         pages.loadPageChildren(page)
                "
                (dblclick)="
                    page.kind == 'directory'
                        ? null
                        : pages.addTab(page, item, false)
                "
                style="cursor: default;"
            >
                <div class="placeholder" *cdkDragPlaceholder></div>
                <mat-expansion-panel-header
                    cdkDragHandle
                    [style.color]="'var(--text-color)'"
                >
                    <div
                        class="label"
                        [ngx-contextmenu]="ctxMenu"
                        [ngx-menu-context]="page"
                        [matTooltip]="page.label"
                        [matTooltipShowDelay]="750"
                    >
                        @if (page.icon) {
                            <mat-icon
                                [fontIcon]="page.icon"
                                [style.color]="page.color"
                            />
                        }
                        @else if (page.kind == "directory") {
                            <!-- Show a progress indicator when fetching children -->
                            @if (page.loading) {
                                <mat-progress-spinner
                                    mode="indeterminate"
                                    diameter="18"
                                    style="margin: 2px"
                                />
                            }
                            @else {
                                <mat-icon
                                    [fontIcon]="page.expanded ? 'folder_open' : 'folder'"
                                    [style.color]="page.color"
                                />
                            }
                        }
                        @if (page.kind == "directory") {
                            <span [matTooltip]="page.path + page.filename">{{page.filename?.slice(0, 20)}}</span>
                        }
                        @else {
                            <span>{{page.label?.slice(0, 20) || page.filename.slice(0, 20) || "UNKNOWN"}}</span>
                        }
                    </div>
                </mat-expansion-panel-header>

                @if (page.kind == "directory") {
                    <app-entry-list
                        [item]="page"
                        [items]="page['children']"
                        [depth]="depth + 1"
                    />
                }
            </mat-expansion-panel>
        }
    </mat-accordion>
}
@else {
    <div class="empty"><div>empty</div></div>
}

<!-- Only show this on the root level (this component is recursive) -->
@if (depth == 0) {
    <hr/>

    <div class="add-line">
        <span [ngx-tooltip]="addTooltip" [ngx-tooltip-config]="{ position: 'bottom', triggers: ['click'], stayOpen: true }">
            <mat-icon>note_add</mat-icon>
            New
        </span>
        <ng-template #addTooltip>
            <div class="add__list">
                <span class="add__btn" (click)="createDirectory(item)">
                    <mat-icon>folder</mat-icon>
                    Folder
                </span>
                <span class="add__btn" (click)="create('markdown', 'markdown')">
                    <mat-icon>markdown</mat-icon>
                    Markdown
                </span>
                <span class="add__btn" (click)="create('code', 'code_blocks')">
                    <mat-icon>code_blocks</mat-icon>
                    Code
                </span>
                <span class="add__btn" (click)="create('canvas', 'network_node')">
                    <mat-icon>network_node</mat-icon>
                    Diagram
                </span>
            </div>
        </ng-template>
        <!-- This one is very broken everywhere. -->
        <!-- <span (click)="create('fetch')">
            <mat-icon>add</mat-icon>
            Fetch
        </span> -->
    </div>
}

<ng-template #renameTemplate let-data let-dialog="dialog">
    <app-folder-rename
        [dialog]="dialog"
        [data]="data"
    />
</ng-template>
